import React, { useEffect, useMemo, useState } from 'react';
import axios from 'axios';
import { API_URL, authHeaders } from './utils';
import FilterBar from './FilterBar';
import '../../components/componenetStyle/ListaUrzadzen.css';
import { useAuth } from '../../auth/AuthContext';

const ListaKategorii = () => {
  const { hasPermission } = useAuth();
  const canManageWarehouse = hasPermission('warehouse_manage');
  const [rows, setRows] = useState([]);
  const [filter, setFilter] = useState('active');
  const [search, setSearch] = useState('');
  const [isAdding, setIsAdding] = useState(false);
  const [newRow, setNewRow] = useState({ nazwa: '', parent_id: '' });
  const [editingId, setEditingId] = useState(null);
  const [edit, setEdit] = useState({ nazwa: '', parent_id: '' });

  const query = useMemo(() => {
    const q = new URLSearchParams();
    if (filter !== 'all') q.set('active', filter === 'active' ? 'true' : 'false');
    if (search.trim()) q.set('search', search.trim());
    q.set('limit', '500');
    return q.toString();
  }, [filter, search]);

  const fetchRows = async () => {
    const { data } = await axios.get(`${API_URL}/slowniki/kategorie?${query}`, { headers: authHeaders() });
    setRows(data || []);
  };

  useEffect(() => { fetchRows(); /* eslint-disable-next-line */ }, [query]);

  const saveAdd = async () => {
    if (!canManageWarehouse) return;
    if (!newRow.nazwa.trim()) return alert('Podaj nazwę kategorii.');
    await axios.post(`${API_URL}/slowniki/kategorie`, {
      nazwa: newRow.nazwa.trim(),
      parent_id: newRow.parent_id || null,
      active: true
    }, { headers: authHeaders() });
    setIsAdding(false);
    setNewRow({ nazwa: '', parent_id: '' });
    fetchRows();
  };

  const beginEdit = (r) => { setEditingId(r.id); setEdit({ nazwa: r.nazwa, parent_id: r.parent_id || '' }); };
  const cancelEdit = () => { setEditingId(null); setEdit({ nazwa: '', parent_id: '' }); };
  const saveEdit = async (id) => {
    if (!canManageWarehouse) return;
    await axios.put(`${API_URL}/slowniki/kategorie/${id}`, {
      nazwa: edit.nazwa?.trim(),
      parent_id: edit.parent_id || null
    }, { headers: authHeaders() });
    cancelEdit();
    fetchRows();
  };

  const archive = async (id) => {
    if (!canManageWarehouse) return;
    if (!window.confirm('Zarchiwizować tę kategorię?')) return;
    await axios.delete(`${API_URL}/slowniki/kategorie/${id}`, { headers: authHeaders() });
    fetchRows();
  };
  const restore = async (id) => {
    if (!canManageWarehouse) return;
    await axios.patch(`${API_URL}/slowniki/kategorie/${id}/restore`, {}, { headers: authHeaders() });
    fetchRows();
  };

  return (
    <div className="lista-urzadzen-container">
      <div className="header">
        <h2>Kategorie magazynu</h2>
        {canManageWarehouse ? <button className="add-button" onClick={() => setIsAdding(true)}>Dodaj nowe</button> : null}
      </div>
      <FilterBar filter={filter} setFilter={setFilter} search={search} setSearch={setSearch} />
      <table className="lista-urzadzen-table">
        <thead>
          <tr>
            <th>ID</th>
            <th>Nazwa</th>
            <th>Nadrzędna</th>
            <th>Akcje</th>
          </tr>
        </thead>
        <tbody>
          {isAdding && (
            <tr>
              <td>Nowa</td>
              <td>
                <input
                  value={newRow.nazwa}
                  onChange={(e) => setNewRow((p) => ({ ...p, nazwa: e.target.value }))}
                  placeholder="Nazwa kategorii"
                />
              </td>
              <td>
                <select
                  value={newRow.parent_id}
                  onChange={(e) => setNewRow((p) => ({ ...p, parent_id: e.target.value }))}
                >
                  <option value="">— brak —</option>
                  {rows.filter(r => r.active !== false).map((r) => (
                    <option key={r.id} value={r.id}>{r.nazwa}</option>
                  ))}
                </select>
              </td>
              <td />
            </tr>
          )}

          {rows.length === 0 ? (
            <tr><td colSpan="4">Brak danych</td></tr>
          ) : rows.map((r) => (
            <tr key={r.id}>
              <td>{r.id}</td>
              {editingId === r.id ? (
                <>
                  <td><input value={edit.nazwa} onChange={(e) => setEdit((p) => ({ ...p, nazwa: e.target.value }))} /></td>
                  <td>
                    <select value={edit.parent_id} onChange={(e) => setEdit((p) => ({ ...p, parent_id: e.target.value }))}>
                      <option value="">— brak —</option>
                      {rows.filter(x => x.id !== r.id && x.active !== false).map((x) => (
                        <option key={x.id} value={x.id}>{x.nazwa}</option>
                      ))}
                    </select>
                  </td>
                  <td>
                    {canManageWarehouse ? <button onClick={() => saveEdit(r.id)}>Zapisz</button> : null}
                    {canManageWarehouse ? <button onClick={cancelEdit}>Anuluj</button> : null}
                  </td>
                </>
              ) : (
                <>
                  <td>{r.nazwa}</td>
                  <td>{rows.find(x => x.id === r.parent_id)?.nazwa || '—'}</td>
                  <td>
                    {r.active ? (
                      <>
                        {canManageWarehouse ? <button onClick={() => beginEdit(r)}>Edytuj</button> : null}
                        {canManageWarehouse ? <button onClick={() => archive(r.id)}>Archiwizuj</button> : null}
                      </>
                    ) : (
                      canManageWarehouse ? <button onClick={() => restore(r.id)}>Przywróć</button> : null
                    )}
                  </td>
                </>
              )}
            </tr>
          ))}
        </tbody>
      </table>

      {isAdding && canManageWarehouse && (
        <div className="new-device-actions">
          <button onClick={saveAdd}>Zapisz</button>
          <button onClick={() => { setIsAdding(false); setNewRow({ nazwa: '', parent_id: '' }); }}>Anuluj</button>
        </div>
      )}
    </div>
  );
};

export default ListaKategorii;
